export const PUBLICATION_FORM_CONSTS = {
  articleMsg: 'статью',
  editMsg: 'Редактировать',
  errorMsg: 'Ошибка',
  newsMsg: 'новость',
  savedMsg: 'Сохранено',
  unknownMsg: 'Неизвестен'
}
